// removed by extract-text-webpack-plugin
module.exports = {"gap_xsm":"14px","gap_sm":"20px","gap_md":"30px","gap_lg":"44px","gap_xlg":"62px","size_o_sm":"28px","size_o_md":"40px","size_o_lg":"56px","size_sm":"24px","size_md":"34px","size_lg":"44px","border_radius":"3px"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-409a5b5a","scoped":false,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Loadmore/Loadmore.vue
// module id = 265
// module chunks = 0